module.exports = __webpack_public_path__ + "static/media/milk-cow-logo.f7412822.png";